// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EngagementCustomersForm from './EngagementCustomersForm';
import EngagementTeamsInterviewedForm from './EngagementTeamsInterviewedForm';
import EngagementSplunkForm from './EngagementSplunkForm';
// css
import '../../styles/components/analytics/Engagement.scss';


class Engagement extends Component {

  render() {
    const {
      engagementItems,
      makeCreateEngagementItem,
      updateEngagementItem,
      deleteEngagementItem
    } = this.props;

    return (
      <div className='analytics__engagement'>
        <div className='row'>
          <div className='col-md-12'>
            <h2>Engagement</h2>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <h3>Customer Stakeholders</h3>
            <EngagementCustomersForm
              items={engagementItems.customer}
              onAddItem={makeCreateEngagementItem('customer')}
              onUpdateItem={updateEngagementItem}
              onRemoveItem={deleteEngagementItem}
            />
          </div>
          <div className='col-md-6'>
            <h3>Teams Interviewed</h3>
            <EngagementTeamsInterviewedForm
              items={engagementItems.team}
              onAddItem={makeCreateEngagementItem('team')}
              onUpdateItem={updateEngagementItem}
              onRemoveItem={deleteEngagementItem}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <h3>Splunk</h3>
            <EngagementSplunkForm
              items={engagementItems.presenter}
              onAddItem={makeCreateEngagementItem('presenter')}
              onUpdateItem={updateEngagementItem}
              onRemoveItem={deleteEngagementItem}
            />
          </div>
        </div>
      </div>
    );
  }
}

Engagement.propTypes = {
  engagementItems: PropTypes.object.isRequired,
  makeCreateEngagementItem: PropTypes.func.isRequired,
  updateEngagementItem: PropTypes.func.isRequired,
  deleteEngagementItem: PropTypes.func.isRequired
};

export default Engagement;



// WEBPACK FOOTER //
// ./src/components/analytics/Engagement.js